<td class="channel-support">
    <p class="channel-support__symbols {isSupported ? 'supported' : 'unsupported'}">
        {#if isSupported}
        <SupportedSymbolButton on:look {channel} {content}/>
        <!-- <LookButton on:look {channel} {content} /> -->
        {:else}
        <UnsupportedSymbol/>
        {/if}
    </p>
</td>

<script>
// import LookButton from "../../ui/buttons/LookButton.html";
import SupportedSymbolButton from "../../ui/buttons/SupportedSymbolButton.html";
import UnsupportedSymbol from "../../ui/symbols/UnsupportedSymbol.html";

export default {
    components: {
        // LookButton,
        UnsupportedSymbol,
        SupportedSymbolButton
    }
}

</script>